<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-11-11 11:03:38
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-21 10:12:36
-->
<template>
  <div>
    <div class="head">
      <div style="display: flex; align-items: center">
        <div class="back" @click="toBack"><a-icon type="arrow-left" /></div>
        <div
          style="
            font-size: 18px;
            color: #303133;
            font-weight: bold;
            margin-left: 12px;
          "
        >
          运行记录
        </div>
      </div>
    </div>
    <div class="search">
            <div style="display:flex">
                <a-range-picker style="width:280px" v-model="time" format="YYYY-MM-DD HH:mm:ss"/>
                <a-select
                showArrow
                allowClear
                v-model="procdefId"
                style="width: 200px; margin-left: 14px;"
                placeholder="按工作流筛选"
                @change="handleChange"
                >
                  <a-select-option  v-for="item in grouplist" :key="item.id">{{item.workFlowName}}</a-select-option>
                </a-select>
                <a-select
                showArrow
                allowClear
                v-model="finished"
                style="width: 200px; margin-left: 14px;"
                placeholder="按状态筛选"
                >
                  <a-select-option :value="true">已结束</a-select-option>
                  <a-select-option :value="false">审核中</a-select-option>
                </a-select>
                 <a-input-group compact>
                    <a-select v-model:value="selectName" style="width:120px;background:#ccc;">
                        <a-select-option @click="selectFn(item.value)" :key="index"  v-for="(item,index) in selectArr">
                            {{item.label}}
                        </a-select-option>
                    </a-select>
                    <a-input v-model:value="value" placeholder="请输入搜索内容" style="width: 173px" />
                </a-input-group>
                <el-button @click="search" type="primary">查询</el-button>
          </div>
    </div>
    <coententTable
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :pagination="pagination"
      :dataSource="dataSource"
      :customSlot="customSlot"
      :loading="listLoading"
      :y="height"
      @handleSizeChange="handleSizeChange"
    >
        <template v-slot:finished="scopeVal">
            <div>{{scopeVal.scope.finished?'结束':'审核中'}}</div>
        </template>
       <template v-slot:operation="scopeVal">
        <div v-if="codeData.indexOf('339') != -1" style="width:66px" @click="toTaboo(scopeVal.scope)" class="btnTwo">查看</div>
      </template>
    </coententTable>
    <recordDetails :itemData="itemData" @closeTwo="closeTwo" :visible="visible"></recordDetails>
  </div>
</template>

<script>
import { runningRecord,list } from "./custom_variables";
import coententTable from "@/components/coentent_table.vue";
import recordDetails from './record_details.vue';
export default {
  data() {
    return {
      height: 0,
      columns: [
        {
          title: "时间",
          dataIndex: "createTime",
          ellipsis: true,
          width: 200,
        },
        {
          title: "稿件名称",
          dataIndex: "title",
          ellipsis: true,
          customCell: column => {
                        return {
                        style: {
                            'min-width': "320px",
                            'max-width': "400px",
                        }
                    };
                    },
                    customHeaderCell: column => {
                    return {
                        style: {
                            'min-width': "320px",
                            'max-width': "400px",
                        }
                    };
          }
        },
        {
          title: "创作人员",
          dataIndex: "createUserName",
          ellipsis: true,
          width: 200,
        },
        {
          title: "响应工作流",
          dataIndex: "procdefName",
          ellipsis: true,
          width: 200,
        },
        {
          title: "结束",
          dataIndex: "endType",
          ellipsis: true,
          width: 200,
        },
         {
          title: "状态",
          dataIndex: "finished",
          ellipsis: true,
          width: 200,
          scopedSlots: { customRender: "finished" },
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 120,
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
      },
      dataSource: [],
      customSlot: [
        {
          name: "finished",
          customRender: "finished",
        },
      ],
      codeData:[],
      grouplist:[],
      finished:undefined,
      procdefId:undefined,
      selectName: "稿件名称",
      selectArr:[
        {
          label:'稿件名称',
          value:'1',
        },
        {
          label:'创作人员',
          value:'2',
        }
      ],
      value:'',
      selectValue:'1',
      time: [],
      listLoading:false,
      visible:false,
      itemData:{},
    };
  },
  components: {
    coententTable,
    recordDetails
  },
  mounted() {
    this.getChatList();
    this.getList();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    handleChange(val){
        this.procdefId = val;
    },
    closeTwo(){
        this.visible = false;
    },
    toBack() {
      this.$router.push({
        path: "/index/configure/workflow_configuration",
      });
    },
    selectFn(value){
        this.selectValue = value;
    },
    toTaboo(item){
        this.visible = true;
        this.itemData = item;
    },
    search() {
       this.pagination.current = 1;
       this.getChatList();
    },
    getList() {
      list({
        siteId: sessionStorage.getItem("siteId"),
      }).then((res) => {
        this.grouplist = res.data;
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getChatList();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getChatList();
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      (":");
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD;
    },
    getChatList() {
      this.listLoading = true;
      let startTime = '';
      let endTime = '';
      if(this.time.length > 0){
        startTime  = this.farmatDate(new Date(this.time[0].toString()).getTime(),'-')
        endTime = this.farmatDate(new Date(this.time[1].toString()).getTime(),'-')
      }
      runningRecord({
        current: this.pagination.current,
        size: this.pagination.pageSize,
        siteId: sessionStorage.getItem("siteId"),
        procdefId:this.procdefId,
        finished:this.finished,
        createUserName:this.selectValue==2?this.value:'',
        title:this.selectValue==1?this.value:'',
        startTime,
        endTime,
      }).then((res) => {
        if (res.code == 0) {
          this.dataSource = res.data.records;
          this.pagination.current = res.data.current;
          this.pagination.total = res.data.total;
          this.pagination.pageSize = res.data.size;
          this.listLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dcdfe6;
  padding: 18px 24px;
}
.back{
  cursor: pointer;
}
 .btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.search {
  padding: 0 24px 0 24px;
  justify-content: space-between;
  display: flex;
  margin-top: 20px;
  /deep/ .ant-select-selection {
    background-color: rgba(245, 247, 250, 1);
    height: 40px;
  }
  /deep/ .ant-input {
    background-color: rgba(245, 247, 250, 1);
    height: 40px;
  }
  /deep/ .el-input__inner {
    background-color: rgba(245, 247, 250, 1);
    height: 40px;
  }
  /deep/ input::-webkit-input-placeholder {
    color: rgba(102, 111, 128, 1);
  }
  /deep/ .ant-select-selection__placeholder {
    color: rgba(102, 111, 128, 1);
  }
  /deep/ .ant-select-selection__rendered {
    line-height: 39px;
  }
  /deep/ .el-select__tags {
    white-space: nowrap;
    overflow: hidden;
  }
  /deep/ .el-select__tags {
    flex-wrap: nowrap;
  }
}
.el-button--primary {
  background: #176de6;
}
/deep/ .ant-input-group{
  width: auto;
  margin-right: 14px;
  margin-left: 14px;
}
</style>    